import SendItLaterIcon from "@/assets/icons/send-it-later.svg?react";
import { TranslationData } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";

interface IProps {
  status: boolean;
  disabled: boolean;
  onToggle: () => void;
  translations: TranslationData;
}

const SendItLater = ({ disabled, onToggle, status, translations }: IProps) => {
  return (
    <button
      onClick={onToggle}
      disabled={disabled}
      className={cn(
        "flex w-full cursor-pointer items-center border transition-all disabled:cursor-not-allowed",
        status && "ring-2 ring-tertiary-3",
      )}
    >
      <div className="flex w-16 shrink-0 self-stretch items-center justify-center border-r min-h-[4rem]">
        <SendItLaterIcon />
      </div>
      <div className="w-full bg-tertiary-3 p-4 text-start">
        <h3 className="text-sm font-semibold">
          {translations?.lensConfigurator?.lens_config_review_section_send_it_later_title}
        </h3>
        <p className="text-[0.75rem] text-tertiary-6">
          {translations?.lensConfigurator?.lens_config_review_section_send_it_later_subtitle}
        </p>
      </div>
    </button>
  );
};

export default SendItLater;
